const VIMEO_PLAYER_SCRIPT_SRC = "https://player.vimeo.com/api/player.js";

export function loadVimeoPlayerApi() {
  return new Promise((resolve, reject) => {
    if (typeof window === "undefined") {
      resolve();
      return;
    }

    if (window.Vimeo?.Player) {
      resolve(window.Vimeo.Player);
      return;
    }

    let script = document.querySelector(
      `script[src="${VIMEO_PLAYER_SCRIPT_SRC}"]`
    );

    const onLoad = () => {
      if (window.Vimeo?.Player) {
        resolve(window.Vimeo.Player);
      } else {
        reject(new Error("Vimeo Player API failed to load"));
      }
    };

    if (script) {
      script.addEventListener("load", onLoad);
      if (window.Vimeo?.Player) onLoad();
      return;
    }

    script = document.createElement("script");
    script.src = VIMEO_PLAYER_SCRIPT_SRC;
    script.async = true;
    script.addEventListener("load", onLoad);
    script.addEventListener("error", () =>
      reject(new Error("Vimeo Player API failed to load"))
    );
    document.head.appendChild(script);
  });
}

const decodeHtml = (value = "") =>
  value
    .replace(/&amp;/g, "&")
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">");

/**
 * Reads a Vimeo video id (and optional privacy hash) from an embed iframe,
 * player URL, or page URL.
 */
export function parseVimeoSource(rawUrl) {
  if (!rawUrl || typeof rawUrl !== "string") return null;

  const source = decodeHtml(rawUrl.trim());
  const iframeSrcMatch = source.match(/src=["']([^"']+)["']/i);
  const candidate = iframeSrcMatch ? iframeSrcMatch[1] : source;

  const playerMatch = candidate.match(
    /https?:\/\/player\.vimeo\.com\/video\/(\d+)[^\s"']*/i
  );
  const pageMatch = candidate.match(
    /vimeo\.com\/(?:channels\/[^/]+\/|groups\/[^/]+\/videos\/|video\/)?(\d+)/i
  );
  const id = playerMatch?.[1] || pageMatch?.[1];
  if (!id) return null;

  const queryHash = candidate.match(/[?&]h=([a-zA-Z0-9]+)/);
  const pathHash = candidate.match(/vimeo\.com\/\d+\/([a-zA-Z0-9]+)/i);
  const hash = queryHash?.[1] || pathHash?.[1] || null;

  if (playerMatch?.[0]) {
    return {
      id,
      hash,
      embedUrl: playerMatch[0],
    };
  }

  const embedUrl = new URL(`https://player.vimeo.com/video/${id}`);
  if (hash) embedUrl.searchParams.set("h", hash);

  return {
    id,
    hash,
    embedUrl: embedUrl.toString(),
  };
}
